import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Hero1, Hero2, Hero3, HeroFullVideo } from "@/components/ui/Hero";
import { Hero4 } from "@/components/ui/Hero/Hero4";
import { sbLink } from "@/lib/storyblok/link";
import type {
	BlokHero1,
	BlokHero2,
	BlokHero3,
	BlokHero4,
	BlokHeroFullVideo,
} from "@/storyblok";

export const HeroBlok1 = ({ blok }: BlokProps<BlokHero1>) => {
	const href = blok.link ? sbLink(blok.link)?.href : undefined;

	return (
		<BlokWrap editable={blok} asChild>
			<Hero1
				mainTitle={blok.mainTitle}
				secondaryTitle={blok.secondaryTitle}
				mainSource={blok.mainAsset}
				secondarySource={blok.secondaryAsset}
				href={href}
				lightMode={blok.lightMode}
			/>
		</BlokWrap>
	);
};

export const HeroBlok2 = ({ blok }: BlokProps<BlokHero2>) => {
	const link = blok?.link?.at(0);
	const href = link ? sbLink(link.href)?.href : undefined;

	return (
		<BlokWrap editable={blok} asChild>
			<Hero2
				mainTitle={blok.mainTitle}
				secondaryTitle={blok.secondaryTitle}
				mainSource={blok.mainAsset}
				secondarySource={blok.secondaryAsset}
				href={href}
				linkText={link?.text}
				linkVariant={blok.linkVariant}
				lightMode={blok.lightMode}
			/>
		</BlokWrap>
	);
};

export const HeroBlok3 = ({ blok }: BlokProps<BlokHero3>) => {
	const link = blok?.link?.at(0);
	const href = link ? sbLink(link.href)?.href : undefined;

	return (
		<BlokWrap editable={blok} asChild>
			<Hero3
				mainTitle={blok.mainTitle}
				secondaryTitle={blok.secondaryTitle}
				preamble={blok.preamble}
				mainSource={blok.asset}
				assetPadding={blok.assetPadding}
				href={href}
				linkText={link?.text}
				linkVariant={blok.linkVariant}
				lightMode={blok.lightMode}
			/>
		</BlokWrap>
	);
};

export const HeroBlok4 = ({
	blok,
	tag,
}: BlokProps<BlokHero4> & {
	tag?: string;
}) => {
	return (
		<BlokWrap editable={blok} asChild>
			<Hero4
				heading={blok.heading}
				image={blok.image}
				preamble={blok.preamble}
				tag={tag}
			/>
		</BlokWrap>
	);
};

export const HeroBlokFullVideo = ({
	blok,
	preview,
}: BlokProps<BlokHeroFullVideo>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<HeroFullVideo
				mainTitle={blok.mainTitle}
				secondaryTitle={blok.secondaryTitle}
				mainSource={blok.mainAsset}
				lightMode={blok.lightMode}
				cta={
					blok.link?.length ? (
						<StoryblokComponentList bloks={blok.link} preview={preview} />
					) : undefined
				}
			/>
		</BlokWrap>
	);
};
